import type { ProjectViewBid } from './project-view-bids.model';

export function hasBidUpgrade(
  bid: Pick<ProjectViewBid, 'sponsored' | 'sealed' | 'highlighted'>,
): boolean {
  return (
    (bid.sponsored !== undefined && bid.sponsored !== 0) ||
    bid.sealed === true ||
    bid.highlighted === true
  );
}
